import { render, staticRenderFns } from "./TOrganisationalScorecard.vue?vue&type=template&id=69c87ff8&scoped=true"
import script from "./TOrganisationalScorecard.vue?vue&type=script&lang=js"
export * from "./TOrganisationalScorecard.vue?vue&type=script&lang=js"
import style0 from "./TOrganisationalScorecard.vue?vue&type=style&index=0&id=69c87ff8&prod&lang=css"
import style1 from "./TOrganisationalScorecard.vue?vue&type=style&index=1&id=69c87ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c87ff8",
  null
  
)

export default component.exports